/* (ignored) */


//////////////////
// WEBPACK FOOTER
// jsdom (ignored)
// module id = 1
// module chunks = main